import { ButtonDetails } from "../../../resources/modelTypes";
import { SectionComponentProps } from "../../types";
import { Button as FancyButton } from "@minted/fancyclothes";
import React, { memo } from "react";

const DisplayButtonSection = ({ section }: SectionComponentProps) => {
  const details = section.sectionDetails as ButtonDetails;

  return (
    <>
      {details.websiteUrl && (
        <FancyButton text={details.buttonText} url={details.websiteUrl} />
      )}
    </>
  );
};

const MemoizedDisplayButtonSection = memo(DisplayButtonSection);

export { MemoizedDisplayButtonSection as DisplayButtonSection };
